var render, staticRenderFns
import script from "./ouaSelect.vue?vue&type=script&lang=js&"
export * from "./ouaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/items/ouaSelect.vue"
export default component.exports